require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-c-5-p-nio-nl-7-m-8-u-4-ha-1-q-jc-87-vz.json") })
        }
      }, "path---news-c-5-p-nio-nl-7-m-8-u-4-ha-1-q-jc-87-vz");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-c-5-p-nio-nl-7-m-8-u-4-ha-1-q-jc-87-vz!./.cache/json/news-c-5-p-nio-nl-7-m-8-u-4-ha-1-q-jc-87-vz.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-c-5-p-nio-nl-7-m-8-u-4-ha-1-q-jc-87-vz!./.cache/json/news-c-5-p-nio-nl-7-m-8-u-4-ha-1-q-jc-87-vz.json
// module chunks = 231608221292675